import React from 'react'
import Heading from '@amzn/meridian/heading'
import Row from '@amzn/meridian/row'
import Button from '@amzn/meridian/button'
import Icon from '@amzn/meridian/icon'
import closeSmallTokens from '@amzn/meridian-tokens/base/icon/close-small'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { HEADER_TEXT } from '../constants'

interface IHeaderProps {
    onClose?: () => void
}

/**
 * Header Component
 *
 * Displays the instructional header text for the store selection page
 * with an optional close button.
 */
export const Header: React.FC<IHeaderProps> = ({ onClose }) => {
    const isHidden = !onClose
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
    <Row alignmentHorizontal="justify" alignmentVertical="center">
      <Heading level={5} data-atb-id="store-selection-heading">
        {t(bundle, HEADER_TEXT)}
      </Heading>
      <Button
        type="icon"
        size="small"
        onClick={isHidden ? undefined : onClose}
        className={isHidden ? 'close-button-hidden' : undefined}
        data-testid="close-store-selector"
      >
          <Icon tokens={closeSmallTokens}>{t(bundle, 'jsma-web-common-close')}</Icon>
      </Button>
    </Row>
    )
}
